// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__19mDM","label":"Radio_label__1H5SY","checkMark":"Radio_checkMark__IOAvf","disabled":"Radio_disabled__2puT7"};